import { defineComponent, computed, openBlock, createElementBlock, normalizeClass, createElementVNode, createVNode, unref, createCommentVNode, createBlock, withCtx, createTextVNode } from "vue";
import { CdrImg, CdrText, CdrButton } from "@rei/cedar";
const _hoisted_1 = {
  class: "retention-billboard__tiles"
};
const _hoisted_2 = {
  class: "retention-billboard__tile retention-billboard__tile--product-image"
};
const _hoisted_3 = {
  class: "retention-billboard__sat-guar-stamp"
};
const _hoisted_4 = ["srcset"];
const _hoisted_5 = {
  class: "retention-billboard__offer"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  class: "retention-billboard__terms-container"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "RetentionBillboard",
  props: {
    imageTileAlt: {
      default: ""
    },
    imageTileSrc: {
      default: ""
    },
    isInterstitial: {
      type: Boolean,
      default: false
    },
    heading: {
      default: ""
    }
  },
  emits: ["metricsClick", "retentionDetailsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const location = computed(() => props.isInterstitial ? "interstitial" : "on-page");
    const handleShowDetails = () => {
      emit("metricsClick", {
        linkName: `retention membership billboard ${location.value}_details`
      });
      emit("retentionDetailsClick", {
        id: "retention-billboard-modal",
        label: "Details",
        labelIsTitle: true,
        modalContent: "RetentionBillboardModal"
      });
    };
    const containerClasses = computed(() => ({
      "retention-billboard": true,
      [`retention-billboard--${location.value}`]: true
    }));
    const satGuarStamp = "https://www.rei.com/dam/21524923_100-percent-satisfaction-guaranteed.png";
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(containerClasses.value)
      }, [createElementVNode("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [createVNode(unref(CdrImg), {
        src: _ctx.imageTileSrc,
        alt: _ctx.imageTileAlt
      }, null, 8, ["src", "alt"])])]), createElementVNode("div", _hoisted_3, [createElementVNode("picture", null, [createElementVNode("source", {
        media: "(-webkit-min-device-pixel-ratio: 1.5)",
        srcset: satGuarStamp,
        sizes: "160px"
      }), createElementVNode("source", {
        srcset: `${satGuarStamp}?im=Resize,width=180&density=1`,
        sizes: "160px"
      }, null, 8, _hoisted_4), createElementVNode("img", {
        src: satGuarStamp,
        alt: "100 percent satisfaction guaranteed"
      })])]), createElementVNode("div", _hoisted_5, [_ctx.heading ? (openBlock(), createElementBlock("h2", {
        key: 0,
        class: "retention-billboard__heading",
        innerHTML: _ctx.heading
      }, null, 8, _hoisted_6)) : createCommentVNode("", true), createElementVNode("div", _hoisted_7, [_ctx.isInterstitial ? (openBlock(), createBlock(unref(CdrText), {
        key: 0,
        class: "retention-billboard__subheading"
      }, {
        default: withCtx(() => _cache[0] || (_cache[0] = [createTextVNode(" Exclusions apply. ")])),
        _: 1,
        __: [0]
      })) : createCommentVNode("", true), createVNode(unref(CdrButton), {
        class: "retention-billboard__details",
        "data-ui": "retention-billboard-details-button",
        modifier: "link",
        "aria-label": "terms",
        onClick: handleShowDetails
      }, {
        default: withCtx(() => _cache[1] || (_cache[1] = [createElementVNode("sup", null, "*", -1), createElementVNode("span", null, "Details", -1)])),
        _: 1,
        __: [1]
      })])])], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=RetentionBillboard.mjs.map
